import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Icon, IconButton, ResponsiveDialog, Stack, Text, TextArea, TextInput } from 'shell/components';

const EditCriterionDialog = ({ open, criterion, onClose, onSave, onDelete }) => {
    const { t } = useTranslation('assignment');
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);

    const { id, title, description } = criterion;

    const handleSubmit = () => {
        onSave(id, titleRef.current.value, descriptionRef.current.value);
    };

    return (
        <ResponsiveDialog aria-labelledby={'dialog-title'} open={open} onClose={onClose}>
            <Stack sx={{ minWidth: '300px' }} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text id={'dialog-title'} component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('rubric.criterion-form.edit-title', 'Edit Criterion')}
                    </Text>
                    <IconButton
                        aria-label={'close'}
                        kind={'exit'}
                        size={'medium'}
                        variant={'square'}
                        onClick={onClose}
                    />
                </Stack>
                <Form onSubmit={handleSubmit}>
                    <Stack spacing={4}>
                        <TextInput
                            ref={titleRef}
                            autoFocus
                            defaultValue={title}
                            label={t('rubric.criterion-form.criterion-label', 'Name')}
                            placeholder={t('rubric.criterion-form.criterion-placeholder', 'Enter criterion name')}
                        />
                        <TextArea
                            ref={descriptionRef}
                            defaultValue={description}
                            label={t('rubric.criterion-form.description-label', 'Description')}
                            placeholder={t(
                                'rubric.criterion-form.description-placeholder',
                                'Enter criterion description'
                            )}
                            rows={4}
                        />
                        <Stack direction={'row'} justifyContent={'space-between'}>
                            <Button
                                color={'destructive'}
                                startIcon={<Icon kind={'delete'} />}
                                type={'button'}
                                variant={'tertiary'}
                                onClick={() => onDelete(criterion.id)}
                            >
                                {t('common:controls.delete', 'Delete')}
                            </Button>
                            <Button type={'submit'}>{t('common:controls.save', 'Save')}</Button>
                        </Stack>
                    </Stack>
                </Form>
            </Stack>
        </ResponsiveDialog>
    );
};

export default EditCriterionDialog;
